import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("NewsWidget", {
  title: "News Widget",
  attributes: {
    destination: {
      title: "Destination",
    },
  },
  properties: ["destination"],
  initialContent: {
    color: "blue",
    headline: "Lorem Ipsum",
  },
});
